import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import ArgusStatePanel from './ui/ArgusStatePanel'

export default function ProtectedRoute() {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <ArgusStatePanel
        variant="loading"
        eyebrow="ARGUS // IDENTITY"
        title="Checking your access"
        message="ARGUS is restoring your authenticated identity and active workspace permissions."
        fullScreen
      />
    )
  }

  return user ? <Outlet /> : <Navigate to="/login" replace />
}
